import useRecaptchaV3 from '../../domains/landing-autos/hooks/use-recaptcha-v3';

const RecaptchaConsumer = () => {
  useRecaptchaV3();
  return <div />;
};

export default RecaptchaConsumer;
